import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { resetQueries } from '@/utils'

import { RESERVATION_NOTES_QUERY_KEY } from './get-reservation-notes'

export type RemoveReservationNoteRequest = {
  reservationId: string
  noteId: number
}

const removeReservationNote = async ({ reservationId, noteId }: RemoveReservationNoteRequest) => {
  const result = await authAPI.delete(`/reservation/${reservationId}/notes/${noteId}`)

  return result.data
}

export const useRemoveReservationNote = () => {
  return useMutation({
    mutationFn: removeReservationNote,
    onError: () => {
      toastFactory.error(i18n.t('common:errors.generic'))
    },
    onSuccess: async () => {
      await resetQueries([RESERVATION_NOTES_QUERY_KEY])
      toastFactory.success(i18n.t('reservations:details.apiMessages.deleteSuccess'))
    },
  })
}
